import React from 'react'
import { getWorkPatternJP } from '@medical/constant/utilities'

export const getIconContent = workPattern => {
  switch (workPattern) {
    case 'PERMANENT_DOCTOR':
      return '常'
    case 'REGULAR_SHIFT_DOCTOR':
      return '非'
    case 'IRREGULAR_SHIFT_DOCTOR':
    case 'TEMPORARY_DOCTOR':
      return 'ス'
    default:
      return 'ス'
  }
}

const EmploymentClassificationIcon = ({ workPattern, className = '' }) => {
  const getIconColor = workPattern => {
    switch (workPattern) {
      case 'PERMANENT_DOCTOR':
        return '#87CEEB'
      case 'REGULAR_SHIFT_DOCTOR':
        return '#DDA0DD'
      case 'IRREGULAR_SHIFT_DOCTOR':
      case 'TEMPORARY_DOCTOR':
        return '#F0E68C'
      default:
        return '#F0E68C'
    }
  }

  const iconContent = getIconContent(workPattern)

  if (!iconContent) {
    return null
  }

  return (
    <span
      className={`employment-classification-icon ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        backgroundColor: getIconColor(workPattern),
        color: '#000000',
        fontSize: '12px',
        fontWeight: 'bold',
        marginRight: '8px',
        flexShrink: 0,
      }}
      title={getWorkPatternJP(workPattern)}
    >
      {iconContent}
    </span>
  )
}

export default EmploymentClassificationIcon
